// Global stuff that runs on all corporate pages

const Clipboard = require('Vendor/clipboard');

module.exports = function GlobalCorporate() {

	this.init = function() {
		this.setupClipboard();
		if (typeof(checkStripe) !== "undefined" && checkStripe) {
			this.checkStripe();
		}
	}

	// We use ClipboardJS to copy links
	this.setupClipboard = function() {
		if(!Clipboard.isSupported()) { return; }

		var copied = new Clipboard('.js-copy');

		copied.on('success', function(e) {
			console.log("Copied: " + e.text);

			e.clearSelection();
			var successTarget = $(e.trigger).data('clipboardSuccess');

			if(successTarget){
				$(successTarget).collapse('show');

				if($(e.trigger).data('clipboardHide')){
					setTimeout(function() {
						$(successTarget).collapse("hide");
					}, 3000);
				}
			}
		});
	}

	this.grey = function(text) {
		return '<span class="text-grey-50">' + text + '</span>';
	}

	// Global variables
	window.EA = {
		// How long the slide animation takes - used for alert boxes on various forms
		slideMs: 300,

		// Global variables for reports
		reports: {
			// this is what goes into cells where the user's details have been GDPRed out
			anonHtml: this.grey('Anonymous'),

			// very occasionally, teh date field is missing, this is what replaces
			missingHtml: this.grey('No information'),

			// more blank placeholder
			notProvidedHtml: this.grey('Not provided'),
			notFromCpHtml: this.grey('No Campaign page'),
			notFromFpHtml: this.grey('No Fundraising Page'),
			notFromTpHtml: this.grey('No Ticketing Page'),
			notFromCorpHtml: this.grey('No corporate'),
			notKnown: this.grey('Not known'),

			// Used for corporate free plans
			basicPlan: this.grey('Not available in Basic Plan'),

			// Date format used for everything
			dateFormat: "YYYY-MM-DD"
		}
	};

	var self = this;
	self.init();
}